/**
 * Sacoche Chic — Compte à rebours de promotion.
 *
 * Met à jour chaque seconde tous les blocs portant data-sc-promo-end, et les
 * masque une fois l'échéance passée (cas d'un onglet resté ouvert).
 *
 * Le bloc peut apparaître deux fois sur une page (bandeau d'annonce et fiche
 * produit) : le script est donc chargé deux fois, mais ne s'installe qu'une.
 */
(function () {
  if (window.scPromoCountdownReady) return;
  window.scPromoCountdownReady = true;

  var SELECTOR = '[data-sc-promo-end]';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function fill(root, attr, value) {
    var el = root.querySelector('[' + attr + ']');
    if (el && el.textContent !== value) el.textContent = value;
  }

  function update() {
    var blocks = document.querySelectorAll(SELECTOR);
    if (!blocks.length) return;

    var now = Date.now();

    Array.prototype.forEach.call(blocks, function (block) {
      var end = Date.parse(block.getAttribute('data-sc-promo-end'));

      // Date illisible : on laisse le bloc tel quel plutôt que de le masquer.
      if (isNaN(end)) return;

      var left = end - now;
      if (left <= 0) {
        block.hidden = true;
        return;
      }

      var total = Math.floor(left / 1000);
      var days = Math.floor(total / 86400);
      var daysUnit = block.querySelector('[data-sc-promo-days]');

      if (daysUnit) daysUnit.hidden = days === 0;
      if (days > 0) fill(block, 'data-sc-promo-d', String(days));

      fill(block, 'data-sc-promo-h', pad(Math.floor((total % 86400) / 3600)));
      fill(block, 'data-sc-promo-m', pad(Math.floor((total % 3600) / 60)));
      fill(block, 'data-sc-promo-s', pad(total % 60));
    });
  }

  update();
  setInterval(update, 1000);

  // Le thème re-rend des sections (changement de variante, éditeur) : le bloc
  // réapparaît alors avec ses valeurs d'origine, à rafraîchir aussitôt.
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:block:select', update);
})();
